import { STORAGE_KEYS } from '../config/app';

/**
 * Where the header cart is kept: one key PER PERSON, cleared on Sign Out,
 * View As and impersonation (AuthContext). The cart used to live under one
 * shared key, so the next person to sign in on a shared machine inherited the
 * last person's cart and could check it out (dead-end audit 2026-10-01, U4-17).
 *
 * In its own module, beside the hook, because AuthContext clears it and the
 * hook reads AuthContext — the same arrangement as roomAccessCache.
 */
const PREFIX = `${STORAGE_KEYS.BOOKING_CART}:`;

/** The cart key for one signed-in person, or null when nobody is. */
export function cartKey(userId) {
  return userId === null || userId === undefined ? null : `${PREFIX}${userId}`;
}

export function readCart(key) {
  if (!key) return [];
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeCart(key, items) {
  if (!key) return;
  try {
    localStorage.setItem(key, JSON.stringify(items));
  } catch {
    /* storage blocked: the cart lasts as long as the page */
  }
}

/** Forget every saved cart in this browser, including the old shared one. */
export function clearSavedCarts() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k && (k === STORAGE_KEYS.BOOKING_CART || k.startsWith(PREFIX))) keys.push(k);
    }
    keys.forEach((k) => localStorage.removeItem(k));
  } catch {
    /* nothing to clear */
  }
}
